const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');

const RestaurantSepaForm = require('app/restaurant/sepa/Form');

class SepaTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'restaurant': {'id':null,'name':null},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);


        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.restaurant = this.settings.restaurant;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.loadData();
    }


    loadData(){
        var self = this;

        let queries = [
            this.buildSepaQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildTab(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildSepaQuery(){
        var self = this;

        let id = this.restaurant.id;
        let parameters = {
            'id': id,
        };

        let fields = [
            'sepas { companyName address zipCode city signedAt bic iban rum signatureCity }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurant',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }


    buildTab(data){
        let sepas = data.restaurant.sepas;

        this.sepa = sepas.length > 0 ? sepas[0] : {};

        this.$container
        .html('')
        .append(this.buildForm());

        this.form.onDOMReady();
    }

    buildForm(){
        this.form = new RestaurantSepaForm({
            'restaurant': this.restaurant,
            'sepa': this.sepa
        });

        return this.form.getForm();
    }


}

module.exports = SepaTab;

